<div class="d-flex flex-column align-items-stretch wrapper">
    <div class="d-flex align-items-center mb-3" *ngIf="label || icon">
        <i class="icon {{icon}} me-2" *ngIf="icon"></i>
        <div *ngIf="label" class="font-large color-greyish">{{label | translate}}</div>
    </div>
    <div class="d-flex align-items-center" #selectContainerRef>


        <!-- Se deshabilita que virtualScroll dependa de si es read only && virtualScroll para solo ser dependiente de esto segundo  -->
        <p-multiSelect #multiple class="multi-select-custom multiple" *ngIf="selectionMode === 'multiple'"
        [styleClass]="noInput ? 'remove-input custom-multi-select enable-select form-multi-select multiple' : 'custom-multi-select enable-select form-multi-select multiple' "
        styleClass="custom-multi-select form-multi-select" dropdownIcon="icon icon-16-px-dropdown" [options]="data"
        (onChange)="onChangeHandler($event)" placeholder="{{placeholder | translate}}" [dataKey]="fieldTranslation"
        optionLabel="{{fieldTranslation}}" [formControl]="form" [showToggleAll]="showToggleAll"
        [maxSelectedLabels]="maxSelectedLabels || 3" [appendTo]="appendTo || 'body'"
        overlayVisible="{{overlayVisible}}"  [readonly]="readonly" (onPanelHide)="onPanelHide($event)"
        [virtualScroll]="readonly ? false : virtualScroll ? true : false" virtualScrollItemSize="38"
        (onPanelShow)="onPanelShow()" [disabled]="disabled">
             <ng-template *ngIf="selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
                <div *ngIf="selectedObjects?.length===0 || !selectedObjects">
                    <span *ngIf="!placeholder">{{ 'NO_SELECTED_ITEMS' | translate }}</span>
                    <span *ngIf="placeholder">{{ placeholder | translate }}</span>
                </div>
                <div *ngIf="selectedObjects?.length > maxSelectedLabels">
                    <span>{{selectedObjects?.length}} {{'ITEM_SELECTED' | translate}}</span>
                </div>
                <ng-container *ngIf="selectedObjects?.length <= maxSelectedLabels && selectedObjects?.length !==0"
                    [ngTemplateOutlet]="selectedItemsTemplate" [ngTemplateOutletContext]="{$implicit:selectedObjects}" />
            </ng-template>
            <ng-template *ngIf="itemTemplate" let-obj let-i="index" pTemplate="item">
                {{obj.NAME}}
                <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{$implicit:obj,index:i}" />
            </ng-template>
            <ng-template *ngIf="!selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
                <div *ngIf="selectedObjects?.length===0 || !selectedObjects">
                    <span *ngIf="!placeholder">{{ 'NO_SELECTED_ITEMS' | translate }}</span>
                    <span *ngIf="placeholder">{{ placeholder | translate }}</span>
                </div>
                <div *ngIf="selectedObjects?.length <= maxSelectedLabels && selectedObjects?.length !==0">
                    <span *ngFor="let object of selectedObjects; let l = last"
                        pTooltip=" {{ object[field] | translate}}">
                        {{ object[field] | translate}}<span *ngIf="!l">, </span>
                    </span>
                </div>
                <div *ngIf="selectedObjects?.length > maxSelectedLabels">
                    <span>{{selectedObjects?.length}} {{'ITEM_SELECTED' | translate}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="!itemTemplate" let-obj let-i="index" pTemplate="item">
                <span *ngIf="obj.label" (click)="optionDisabled(obj?.disabled)"
                    pTooltip="{{obj?.label.toString() | translate}}">{{obj?.label.toString() | translate}}</span>
                <span *ngIf="!obj.label"
                    pTooltip="{{ obj[field] | translate}}">{{ obj[field] | translate}}</span>
            </ng-template>
        </p-multiSelect>


        <p-multiSelect #simple class="multi-select-custom simple" *ngIf="selectionMode === 'simple'"
            [styleClass]="noInput ? 'remove-input custom-multi-select enable-select form-multi-select simple' : 'custom-multi-select enable-select form-multi-select simple' "
            styleClass="custom-multi-select enable-select form-multi-select" dropdownIcon="icon icon-16-px-dropdown" [options]="data"
            (onChange)="onChangeHandler($event)" placeholder="{{placeholder | translate}}" [dataKey]="fieldTranslation"
            optionLabel="{{fieldTranslation}}" [showToggleAll]="false"
            [maxSelectedLabels]="maxSelectedLabels || 3"[appendTo]="appendTo || 'body' "
            overlayVisible="{{overlayVisible}}" [readonly]="readonly" (onPanelHide)="onPanelHide()"
            [virtualScroll]="virtualScroll" [virtualScrollItemSize]="38"
            (onPanelShow)="onPanelShow()" [disabled]="disabled"

            [ngModel]="model" (ngModelChange)="onModelChange($event, false)"
             (onClick)="clicked($event)"
             >
            <ng-template *ngIf="selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
                <ng-container [ngTemplateOutlet]="selectedItemsTemplate"
                    [ngTemplateOutletContext]="{$implicit:selectedObjects}" />
            </ng-template>

            <ng-template *ngIf="itemTemplate" let-obj let-i="index" pTemplate="item">
                {{obj.NAME}}
                <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{$implicit:obj,index:i}" />
            </ng-template>

            <ng-template *ngIf="!selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
                <div *ngIf="selectedObjects?.length===0 || !selectedObjects">
                    <span *ngIf="!placeholder">{{ 'NO_SELECTED_ITEMS' | translate }}</span>
                    <span *ngIf="placeholder">{{ placeholder | translate }}</span>
                </div>
                <div *ngIf="selectedObjects">
                    <span *ngFor="let object of selectedObjects"
                        pTooltip="{{ object[field] | translate}}">{{ object[field] | translate}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="!itemTemplate" let-obj let-i="index" pTemplate="item">
                <span *ngIf="obj.label" (click)="optionDisabled(obj?.disabled)"
                    pTooltip="{{obj?.label.toString() | translate}}">{{obj?.label.toString() | translate}}</span>
                <span *ngIf="!obj.label"
                    pTooltip="{{ obj[field] | translate}}">{{ obj[field] | translate}}</span>
            </ng-template>
        </p-multiSelect>
    </div>

    <!-- TAGS -->
    <p-multiSelect class="multi-select-custom multiple multiselect-tags" *ngIf="selectionMode === 'tags'"
    styleClass="custom-multi-select form-multi-select" dropdownIcon="icon icon-16-px-dropdown" [options]="data"
    (onChange)="onChangeHandler($event)" placeholder="{{placeholder | translate}}" [dataKey]="fieldTranslation"
    optionLabel="{{fieldTranslation}}" [formControl]="form" [showToggleAll]="showToggleAll"
    [maxSelectedLabels]="maxSelectedLabels || 3" [appendTo]="appendTo || 'body'"
    overlayVisible="{{overlayVisible}}" [readonly]="readonly" (onPanelHide)="onPanelHide($event)"
    [virtualScroll]="readonly ? false : virtualScroll ? true : false" virtualScrollItemSize="38"
    (onPanelShow)="onPanelShow()" [disabled]="disabled">
        <ng-template *ngIf="selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
            <div *ngIf="selectedObjects?.length===0 || !selectedObjects">
                <span *ngIf="!placeholder">{{ 'NO_SELECTED_ITEMS' | translate }}</span>
                <span *ngIf="placeholder">{{ placeholder | translate }}</span>
            </div>
            <div *ngIf="selectedObjects?.length > maxSelectedLabels">
                <span>{{selectedObjects?.length}} {{'ITEM_SELECTED' | translate}}</span>
            </div>
            <ng-container *ngIf="selectedObjects?.length <= maxSelectedLabels && selectedObjects?.length !==0"
                [ngTemplateOutlet]="selectedItemsTemplate" [ngTemplateOutletContext]="{$implicit:selectedObjects}" />
        </ng-template>
        <ng-template *ngIf="itemTemplate" let-obj let-i="index" pTemplate="item">
          <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{$implicit:obj,index:i}" />
        </ng-template>
        <ng-template *ngIf="!itemTemplate" let-tag pTemplate="item" class="flex flex-column align-items-center ">
            <div class="mx-1 px-1 row" [ngClass]="'tags'">
                <div class="fw-bold">{{ tag.txtName | translate }}</div>
                <div>
                    <div class="font-small col">{{tag.txtDescription}}</div>
                </div>
                <div>
                    <div class="font-medium mt-2 col">
                      <span *ngIf="tag.relatedTags.length > 0">
                        {{ 'TAG.RELATED' | translate}}
                      </span>
                      <ng-container *ngFor="let relatedTag of tag.relatedTags; let last = last">
                        {{relatedTag.relatedTag.txtName}}<span *ngIf="!last">, </span>
                      </ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-multiSelect>

    <!-- RISKS -->
    <p-multiSelect class="multi-select-custom multiple multiselect-risk" *ngIf="selectionMode === 'risks'"
      styleClass="custom-multi-select form-multi-select" dropdownIcon="icon icon-16-px-dropdown" [options]="data"
    (onChange)="onChangeHandler($event)" placeholder="{{placeholder | translate}}" [dataKey]="fieldTranslation"
      optionLabel="{{fieldTranslation}}" [formControl]="form" [showToggleAll]="showToggleAll"
      [maxSelectedLabels]="maxSelectedLabels || 3" [appendTo]="appendTo || 'body'" overlayVisible="{{overlayVisible}}"
      panelStyleClass="risk-panel"
    [readonly]="readonly" (onPanelHide)="onPanelHide($event)"
      [virtualScroll]="readonly ? false : virtualScroll ? true : false" virtualScrollItemSize="50"
      (onPanelShow)="onPanelShow()" [disabled]="disabled">
      <ng-template *ngIf="selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
        <div *ngIf="selectedObjects?.length===0 || !selectedObjects">
          <span *ngIf="!placeholder">{{ 'NO_SELECTED_ITEMS' | translate }}</span>
          <span *ngIf="placeholder">{{ placeholder | translate }}</span>
        </div>
        <div *ngIf="selectedObjects?.length > maxSelectedLabels">
          <span>{{selectedObjects?.length}} {{'ITEM_SELECTED' | translate}}</span>
        </div>
        <ng-container *ngIf="selectedObjects?.length <= maxSelectedLabels && selectedObjects?.length !==0"
          [ngTemplateOutlet]="selectedItemsTemplate" [ngTemplateOutletContext]="{$implicit:selectedObjects}" />
      </ng-template>
      <ng-template *ngIf="itemTemplate" let-obj let-i="index" pTemplate="item">
          <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{$implicit:obj,index:i}" />
      </ng-template>
      <ng-template let-item #itemTemplate pTemplate="item" class="flex flex-column align-items-center" >
            <div class="mx-1 px-1 row" [ngClass]="{'risks': true, 'miat': item.proposedByMiat === true, 'non-miat': item.proposedByMiat !== true}">
                <div class="fw-bold"><span class="fw-bold" *ngIf="item.proposedByMiat === true">* MIAT: </span>{{ item.riskType.description | translate }}</div>
                    <div>
                        <div class="font-medium col">{{item.riskType.txtDescription | translate}}</div>
                    </div>
                <div>
                    <div class="font-medium mt-2 col">
                        <ng-container class="fw-bold font-medium" *ngIf="item.riskType.relatedRisks.length > 0">
                            {{ 'RISK.RELATED' | translate}}
                        </ng-container>
                        <ng-container *ngFor="let relatedRisk of item.riskType.relatedRisks; let last = last">
                            {{relatedRisk.relatedRisk.description | translate}}<span *ngIf="!last">, </span>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-multiSelect>

    <mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="selectContainerRef"
        [skipHighlighter]="skipHighlighter" />
</div>
